import { render, staticRenderFns } from "./MygProducts.vue?vue&type=template&id=4a09c433"
import script from "./MygProducts.vue?vue&type=script&lang=js"
export * from "./MygProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports